/**
 * 
 * 为了兼容而写
 */

const { CONFIG } = require("../config");


 export const domainApi = {
     pic_domain:CONFIG.domain.getSourceDomain(),
     baby_domain:CONFIG.domain.getApiDomain()
 }
 